<!-- Would have liked to make this an ion-item but there is a problem
when combining with ion-input and type="date" (#10815) -->
<div class="input-container" (click)="input.setFocus()">
  <ion-label>Please enter your response</ion-label>

  <ion-input
    #input
    tabindex="-1"
    [type]="type"
    [autocorrect]="autocorrect"
    enterkeyhint="done"
    autocapitalize="on"
    maxlength="100"
    [formControl]="field"
    (keyup)="onKeyUp($event)"
    (keypress)="onKeyPress($event)"
    (click)="onClick($event)"></ion-input>
</div>
@if (type === 'text') {
  <ion-item lines="none" class="character-count" lines="none">{{ length }}/100</ion-item>
}
